import { translate as t } from '@thoughtspot/i18n';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { Vertical } from "../../../utils/layouts";
import { DependentsModal } from '../common/dependent-objects';
export const TEST_IDS = {
    CUSTOM_CHART_DELETE_MODAL: 'custom-chart-delete-modal',
};
export const CustomChartDeleteModal = ({ customChartIdToBeDeleted, selectedChartName, deleteInProgress, dependentsData, loading, handleOnDeleteConfirmation, handleOnDeleteModalClose, }) => {
    const hasDependentObjects = dependentsData?.length > 0;
    const warningDescription = (React.createElement(Typography, { variant: "body-normal" }, t('customChart.dependency.modal.description')));
    const deletionInstructions = (React.createElement(Typography, { variant: "body-normal" }, t('customChart.dependency.modal.instruction')));
    if (deleteInProgress && hasDependentObjects) {
        return (React.createElement(DependentsModal, { isModalOpen: deleteInProgress && hasDependentObjects, onModalClose: () => {
                handleOnDeleteModalClose();
            }, logicalData: dependentsData, title: t('customChart.dependency.modal.title'), warningDescription: warningDescription, deletionInstructions: deletionInstructions }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { size: ModalSize.SMALL, title: t('customChart.modal.label.deleteChart'), isOpen: !loading && deleteInProgress && !hasDependentObjects, confirmButton: {
                text: t('alert.delete.text'),
                onConfirm: () => handleOnDeleteConfirmation(customChartIdToBeDeleted),
                isLoading: loading,
                isDisabled: loading,
            }, dismissButton: {
                text: t('Cancel'),
                onClick: handleOnDeleteModalClose,
            }, modalTestId: TEST_IDS.CUSTOM_CHART_DELETE_MODAL },
            React.createElement(Vertical, null,
                React.createElement(Typography, { variant: "body-normal" }, t('customChart.delete.modal.description', [
                    selectedChartName,
                ]))))));
};
//# sourceMappingURL=custom-chart-delete-modal.component.js.map